// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"2cba9934","19":"4446f6e7","33":"2b2ae74d","222":"771f9d79","524":"cbb549ea","983":"8f17cba2"}[chunkId] + ".chunk.js";
};